<template>
    <div id="login">
        <div class="login_main  pubw">
            <div class="form">
                <h2>登入</h2>
                <el-form hide-required-asterisk :model="loginForm" :rules="loginRuleForm" ref="loginRuleForm">
                    <el-form-item label="電郵" prop="mail">
                      <el-input v-model="loginForm.mail"></el-input>
                    </el-form-item>
                    <el-form-item label="密碼" prop="password">
                        <el-input v-model="loginForm.password" type="password"></el-input>
                      </el-form-item>
                </el-form>
                <optionsButton class="login" title="登入" :callback="login"/>
                <div class="forget" @click="$router.push('/ForgetPsd')">忘了密碼？</div>
                <div class="regitster" @click="register">免費註冊</div>
            </div>
        </div>
    </div>
</template>

<script>
  // 引入组件
  import optionsButton from '@/components/optionButton'
  import { Loading } from 'element-ui';
export default {
    name:'Login',
    inject:["reloadAll"],
    components:{
        optionsButton
    },
    data(){
        // 验证邮箱正则
        let checkEamil = (rule,value,callback)=>{
            // const regEmail = /^([a-zA-Z0-9_-])+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-])+/
            // const regEmail=/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/;
            const regEmail = /^[A-Za-z0-9/.]+@+[A-Za-z0-9*]+[/.A-Za-z0-9]*$/
            if(!regEmail.test(value)) return callback(new Error('請輸入正確的電郵格式!'))
            return callback()
        }
        return {
            // 登录表单信息
            loginForm:{
                mail:'',
                password:'',
            },
            // 登录表单规则
            loginRuleForm:{
                mail:[
                { required: true, message: '請輸入電子郵箱', trigger: 'blur' },
                {validator:checkEamil,trigger:'blur'}  
                // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                password:[
                { required: true, message: '請輸入密碼', trigger: 'blur' },
                // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        // 监听用户点击登录按钮
        login(){
            this.$refs.loginRuleForm.validate(async valid =>{
                if(!valid) return
                let loadingInstance = Loading.service();
                // 发送登录请求
                let res = await this.$http.post(`app/login/login?email=${this.loginForm.mail}&password=${this.loginForm.password}`)
                if(!res.data.success){
                    this.$message.error(`${res.data.message}`)
                    loadingInstance.close();
                    return
                }
                if(res.data.success){
                    this.$message.success('登入成功！')
                    loadingInstance.close();
                }
                // 存储token到sesstion
                window.sessionStorage.setItem('token',res.data.data)
                let infoRes = await this.$http.post(`app/user/getusercp`)
                if(!infoRes.data.success){
                    loadingInstance.close();
                    this.$message.error("獲取用戶資訊失敗")
                }

                // 存储邮箱到sestion
                window.sessionStorage.setItem('email',infoRes.data.data.email)
                this.$router.push('/mail')
                this.reloadAll()
            })
        },
        // 监听用户点击注册
        register(){
            this.$router.push('/register')
        }
    },
}
</script>

<style lang="less">
    #login{
        background-color: #f4f4f4;
        .login_main{
            display: flex;
            height: 698.18px;
            align-items: center;
            margin:0 auto;
            .form{
                h2{
                    font-size: 30px;
                    margin-bottom:50px;
                    font-weight:550;
                }
                .regitster{
                    width: 75px;
                    text-align: center;
                    border-bottom:2px solid @colorMain;
                    padding-bottom:5px;
                    font-size: 18px;
                    color: @colorMain;
                }
                .regitster:hover{
                    cursor: pointer;
                }
                .el-input__inner{
                    width: 390px;
                    height: 56px;
                    border-radius: 12px;
                }
                .el-input__inner:focus{
                    border-color: @colorMain !important;
                }
                .login{
                    width: 390px;
                    margin: 15px 0;
                }
                .forget{
                    color: #A7A7A7;
                    font-size: 13px;
                    margin:15px 0 30px  ;
                }
                .forget:hover{
                    cursor: pointer;
                }
            }
        }
    }
</style>